import { render, staticRenderFns } from "./timeline.vue?vue&type=template&id=504bc922&scoped=true&"
import script from "./timeline.vue?vue&type=script&lang=js&"
export * from "./timeline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504bc922",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('504bc922')) {
      api.createRecord('504bc922', component.options)
    } else {
      api.reload('504bc922', component.options)
    }
    module.hot.accept("./timeline.vue?vue&type=template&id=504bc922&scoped=true&", function () {
      api.rerender('504bc922', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orders/tabs/timeline.vue"
export default component.exports